﻿import { formatDay } from 'utils/dates';

export function clipText(text: string, length: number) {

    if (text.length > length) {

        return text.slice(0, length).trimEnd() + '...';

    }
    return text;

}

export function clipWords(text: string, numWords: number) {

    const words = text.split(/\s/);
    if (words.length > numWords) {

        return words.slice(0, numWords).join(' ') + '...';

    }
    return words.join(' ');

}

export function clipLines(text: string, numLines: number, maxWidthInCharacters: number) {

    let finalHTML = '';
    const words = text.split(/\s/);
    let currentLineLength = 0;
    let currentLineNumber = 1;
    for (const word of words) {

        if (currentLineLength + word.length > maxWidthInCharacters) {

            if (currentLineNumber === numLines) {

                finalHTML += clipText(word, 1);
                break;

            }
            finalHTML += `<br>` + word + ' ';
            currentLineLength = word.length;
            currentLineNumber++;

        } else {

            finalHTML += word + ' ';
            currentLineLength += word.length;

        }

    }
    return finalHTML;

}

export function toCSV<T>(headers: (Extract<keyof T, string>)[], rows: T[]) {

    let csv = '';
    const headersLength = headers.length;
    for (let i = 0; i < headersLength; i++) {

        csv += `"${headers[i].replace('"', '""')}"${i === (headersLength - 1) ? '' : ','}`;

    }
    csv += '\n';
    const rowsLength = rows.length;
    for (let i = 0; i < rowsLength; i++) {

        const row = rows[i];
        for (let j = 0; j < headersLength; j++) {

            const value = row[headers[j]];
            switch (typeof value) {

                case 'undefined':
                    break;
                case 'bigint':
                case 'number':
                    csv += value;
                    break;
                case 'boolean':
                case 'string':
                    csv += '"' + value + '"';
                    break;
                case 'object':
                case 'function':
                case 'symbol':
                    if (value === null) {

                        break;

                    }
                    throw new Error(`Row values of type '${typeof value}' cannot be serialized.`);

            }
            csv += j === (headersLength - 1) ? '' : ',';

        }
        csv += i === (rowsLength - 1) ? '' : '\n';

    }
    return csv;

}

export function capitalizeEveryFirstLetter(sentenceOrWord: string) {

    return sentenceOrWord.replace(/(^\w{1})|(\s+\w{1})/g, (letter: string) => letter.toUpperCase());

}

export function splitPascalCase(string: string) {

    string = string.replace('&period;', '.');
    return string.replace(/(?<=[a-z])(?=[A-Z][a-z])/, (match, index) => `${index === 0 ? '' : ' '}${match}`);

    // return string.replace(/[A-Z]/g, (match, index) => `${index === 0 ? "" : " "}${match}`)

}

export function toSnakeCase(string: string) {

    return string.replace(/ /g, '-').toLowerCase();

}

export function IdGenerator() {

    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10).toString();

}

export function GenerateUUID() {

    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {

        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);

    });
    return uuid;

}

export const getFormattedDateApi = (inputedDate: Date | string | undefined | null) => formatDay(inputedDate);

export const getFormattedDate = (date: Date | string) => formatDay(date);

export const formatTimeString = (inputNumberOfSeconds: number, hourMinSecondLabel = true) => {

    let returnTimeStringToUse;

    // Test
    //inputNumberOfSeconds = 151200 + 840 + 23; // 42 hours, 14 mins, 23 seconds

    if (inputNumberOfSeconds > 0) {

        // Slice it up
        const hours = Math.floor(inputNumberOfSeconds / 3600);
        const minutes = Math.floor((inputNumberOfSeconds / 60) % 60);
        const seconds = (inputNumberOfSeconds % 60);

        returnTimeStringToUse = hours + `${hourMinSecondLabel ? 'h:' : ':'}`;
        returnTimeStringToUse += minutes + `${hourMinSecondLabel ? 'm:' : ':'}`;
        returnTimeStringToUse += seconds + `${hourMinSecondLabel ? 's' : ''}`;

    } else {

        returnTimeStringToUse = '00h:00m:00s';

    }

    return returnTimeStringToUse;

};

export const emailStringValidation = (email: string) => {

    const emailCheck = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+[^<>()\.,;:\s@\"]{2,})$/;
    return emailCheck.test(email);

};

export const passMeetsRequirements = (password: string) => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*.\-]).{8,}$/.test(password);

// this is the same as the passMeetsRequirements function but will return a list of erros in a string format
export const validatePassword = (password: string): string | null => {

    if (!password) return 'Password is required';
    const issues: string[] = [];
    if (password.length < 8) issues.push('at least 8 characters');
    if (!/[A-Z]/.test(password)) issues.push('one uppercase letter');
    if (!/[a-z]/.test(password)) issues.push('one lowercase letter');
    if (!/[0-9]/.test(password)) issues.push('one number');
    if (!/[#?!@$%^&*.\-]/.test(password)) issues.push('one special character (#?!@$%^&*.-)');
    if (issues.length === 0) return null;
    return `Invalid Password: Must contain ${issues.join(', ')}`;

};
